export enum DropdownMenuSize {
  S = 's',
  M = 'm',
  L = 'l',
}
